// 고객 단계 변경 기록 한 줄 — 쓸 때(저장소 두 벌)와 읽을 때(옛 코드 기록)가 같은 문구를 쓴다.

import type { Activity } from "../quote/types";
import { CUSTOMER_STAGE_LABEL, CUSTOMER_STAGES, type CustomerStage } from "./types";

export const STAGE_CHANGED_ACTION = "customer.stage_changed";

const isStage = (value: unknown): value is CustomerStage =>
  typeof value === "string" && (CUSTOMER_STAGES as readonly string[]).includes(value);

export const stageChangedSummary = (from: CustomerStage, to: CustomerStage): string =>
  `고객 단계 ${CUSTOMER_STAGE_LABEL[from]} → ${CUSTOMER_STAGE_LABEL[to]}`;

// 화면 표기 — 단계 변경은 meta 의 코드로 다시 만들고(옛 기록은 코드값으로 적혀 있다), 나머지는 적힌 그대로.
export const activitySummaryText = (activity: Pick<Activity, "action" | "summary" | "meta">): string => {
  if (activity.action !== STAGE_CHANGED_ACTION) return activity.summary;
  const { from, to } = activity.meta ?? {};
  return isStage(from) && isStage(to) ? stageChangedSummary(from, to) : activity.summary;
};
